<template>
    <v-row>
        <v-col cols="12" sm="6" md="4" offset-md="8" offset-sm="6">
            <search-input @search="performSearch" v-model="search" />
        </v-col>
        <v-col cols="12">
            <div class="table-fixed-header-wrap">
                <v-data-table
                    class="mt-3"
                    fixed-header
                    height="calc(100vh - 260px)"
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :server-items-length="totalItems"
                    :loading="loading"
                    :page.sync="pageNumber"
                    :items-per-page.sync="itemsPerPage"
                    :sort-by.sync="orderBy"
                    :sort-desc.sync="orderDesc"
                    :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                    @update:page="fetch"
                    @update:sort-by="fetch"
                    @update:sort-desc="fetch"
                    @update:items-per-page="fetch"
                >
                    <template slot="no-data">
                        <div class="text-xs-center">Sin datos</div>
                    </template>
                    <template slot="loading">
                        <div class="text-xs-center">Cargando...</div>
                    </template>

                    <template v-slot:item.deposito="{ item }">
                        {{ item.deposito ? item.deposito.nombre : '-' }}
                    </template>

                    <template v-slot:item.activo="{ item }">
                        <v-chip x-small :color="item.activo ? 'success' : 'error'" dark>
                            {{ item.activo ? 'Activo' : 'Inactivo' }}
                        </v-chip>
                    </template>

                    <template v-slot:item.comision="{ item }">
                        {{ item.comision != null ? item.comision + '%' : '-' }}
                    </template>

                    <template v-slot:item.action="{ item }">
                        <show-button @click="$emit('show', item)" />
                        <edit-button @click="$emit('update', item)" />
                        <delete-button @click="$emit('delete', item)" />
                    </template>
                </v-data-table>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import VendedorProvider from "../../../providers/VendedorProvider";
import { EditButton, ShowButton, DeleteButton, SearchInput } from "@dracul/common-frontend";

export default {
    name: "VendedorList",
    components: { EditButton, ShowButton, DeleteButton, SearchInput },
    data() {
        return {
            items: [],
            totalItems: null,
            loading: false,
            orderBy: null,
            orderDesc: false,
            itemsPerPage: 10,
            pageNumber: 1,
            search: "",
        };
    },
    computed: {
        headers() {
            return [
                { text: "Apellido", value: "apellido" },
                { text: "Nombre", value: "nombre" },
                { text: "Email", value: "email" },
                { text: "Teléfono", value: "telefono" },
                { text: "Comisión", value: "comision" },
                { text: "Depósito", value: "deposito", sortable: false },
                { text: "Estado", value: "activo", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ];
        },
        getOrderBy() {
            return Array.isArray(this.orderBy) ? this.orderBy[0] : this.orderBy;
        },
        getOrderDesc() {
            return Array.isArray(this.orderDesc) ? this.orderDesc[0] : this.orderDesc;
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        performSearch() {
            this.pageNumber = 1;
            this.fetch();
        },
        fetch() {
            this.loading = true;
            VendedorProvider.paginateVendedores(
                this.pageNumber,
                this.itemsPerPage,
                this.search,
                this.getOrderBy,
                this.getOrderDesc
            )
                .then((r) => {
                    this.items = r.data.vendedorPaginate.items;
                    this.totalItems = r.data.vendedorPaginate.totalItems;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style scoped>
.table-fixed-header-wrap {
    min-height: 0;
}
</style>
